import styled from 'styled-components'

export default styled.span`
  font-weight: 400;
`
